import _ from 'lodash';

export function TSeriesActivityFeed() {
    const REFRESH_SECONDS = 10;
    const uomify = (() => {
        function equals(f1, f2) {
            if (f1 < f2) return false;
            if (f2 < f1) return false;
            return true;
        }

        function pluralify(singular, plural, value, separator) {
            separator = separator == null ? ' ' : separator;
            if (equals(value, 1)) return '' + value + separator + singular;
            return '' + value + separator + plural;
        }

        return {
            hrs: pluralify.bind(null, 'hour', 'hours'),
            min: pluralify.bind(null, 'min', 'mins'),
            sec: pluralify.bind(null, 'sec', 'secs')
        };
    })();

    function clientModel(serverModel) {
        return {
            id: serverModel.id,
            type: serverModel.type,
            timestamp: serverModel.time, // will be formatted in template
            equipment: {
                id: serverModel.equipmentId,
                name: serverModel.equipmentName,
                meta: {
                    make: serverModel.equipmentMake,
                    model: serverModel.equipmentModel,
                    profile: serverModel.equipmentProfileImage
                }
            },
            location: (serverModel.location || []).length >= 2 ? {
                lat: serverModel.location[1],
                lng: serverModel.location[0]
            } : null,
            value: serverModel.value
        };
    }

    return {
        template: require('./activity-feed.component.html'),
        restrict: 'E',
        scope: {
            //events: '='
        },
        controller: function ($scope, TSeriesService) {

            'ngInject';

            $scope.events = [];
            var timer = null;

            $scope.utilizationString = function (totalhrs) {
                totalhrs = parseFloat(totalhrs);

                var hrs = totalhrs | 0,
                    mns = totalhrs * 60 % 60 | 0,
                    scs = totalhrs * 60 * 60 % 60 | 0,
                    parts = [];

                hrs && parts.push(uomify.hrs(hrs));
                mns && parts.push(uomify.min(mns));
                scs && parts.push(uomify.sec(scs));

                return parts.join(', ');
            };

            function diff(arr1, arr2) {
                var r = [],
                    identity = function (e) {
                        return e.id;
                    },
                    hashset = _.map(arr1, identity);
                for (var i = 0; i < arr2.length; i++) {
                    var item = arr2[i],
                        id = identity(item);
                    if (hashset.indexOf(id) < 0) {
                        hashset.push(id);
                        r.push(item);
                    }
                }
                return r;
            }

            function fetch() {
                TSeriesService
                    .getRecentFleetActivities(100)
                    .then(function (r) {
                        var events = _.map(r.data, clientModel);
                        var newEvents = diff($scope.events, events);
                        [].unshift.apply($scope.events, newEvents);
                        if ($scope.events.length > 100) $scope.events.length = 100;
                        timer = setTimeout(fetch, REFRESH_SECONDS * 1000);
                    });
            }

            fetch();

            // cancel the timer when navigate away.
            $scope.$on('$destroy', function () {
                if (timer) {
                    clearTimeout(timer);
                }
            });
        }
    };
}

export function TSeriesMiniMap() {
    return {
        restrict: 'E',
        scope: {
            location: '='
        },
        template: '',
        replace: true,
        link: function (scope, element) {
            var ll = scope.location;
            if (!ll) return;

            var d = document.createElement('div');
            element.append(d);
            var map = L.map(d, {
                zoomControl: false
            }).setView([ll.lat, ll.lng], 15);
            L.esri.basemapLayer('Streets').addTo(map);
            _.forEach(['dragging', 'touchZoom', 'doubleClickZoom', 'scrollWheelZoom', 'boxZoom', 'keyboard', 'tap'],
                function (feature) {
                    map[feature] && map[feature].disable();
                }
            );

            var dot = L.circleMarker([ll.lat, ll.lng], {
                clickable: false
            });
            dot.setRadius(8);
            dot.addTo(map);
        }
    };
}
